// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7395) return "css/design_system-a9cbaff3463d2027aa75.css";
	if (chunkId === 4861) return "css/4861-26df6bfbbb1076dde711.css";
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"2508":"fcf709e1890ff4fc4a91","2822":"c3cc33eca0fb48afe117","6205":"05fbf81bdcc46309d62e","6862":"e61a0b5836777ee34743","7396":"5e2fdb02a6b02d8e71e7","8092":"c9dab597ae6ab1977962","9127":"56595edd1c39fe3096a3"}[chunkId] + ".css";
};